interface StaticMapPreviewProps {
  latitude: number | undefined
  longitude: number | undefined
  loading: boolean
  error: boolean
  url: string | null
}

export function StaticMapPreview({ latitude, longitude, loading, error, url }: StaticMapPreviewProps) {
  if (latitude == null || longitude == null) return undefined

  if (loading) {
    return (
      <div className="relative w-full bg-gray-100 rounded-xl border border-gray-200 flex items-center justify-center" style={{ aspectRatio: '750/400' }}>
        <div className="animate-spin h-6 w-6 border-2 border-gray-400 border-t-transparent rounded-full" />
      </div>
    )
  }

  if (error || !url) {
    return (
      <div className="relative w-full bg-gray-100 rounded-xl border border-gray-200 flex items-center justify-center text-gray-400 text-sm" style={{ aspectRatio: '750/400' }}>
        Map unavailable
      </div>
    )
  }

  return (
    <img
      src={url}
      alt="Delivery location map"
      className="w-full rounded-xl border border-gray-200 object-cover"
      style={{ aspectRatio: '750/400' }}
    />
  )
}
